"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = recomposeColor;

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;
  var valuesOutput = [];

  if (!type || !values) {
    return '';
  }

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    valuesOutput = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    valuesOutput[0] = values[0];
    valuesOutput[1] = "".concat(values[1], "%");
    valuesOutput[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(valuesOutput.join(', '), ")");
}